import PropTypes from "prop-types";
import { GradientLoaderStyled } from "./styled";

const GradientLoader = ({ width, height, animationDuration = 8, borderRadius = 16 }) => {
  return (
    <GradientLoaderStyled
      width={width}
      height={height}
      animationDuration={animationDuration}
      borderRadius={borderRadius}
    />
  );
};

GradientLoader.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  animationDuration: PropTypes.number,
  borderRadius: PropTypes.number
};

export default GradientLoader;
